import axios from 'axios'

export default class {
  _documentTypeUrl
  _additionalConfig

  constructor() {
    this._documentTypeUrl = `${process.env.VUE_APP_API_MICROSERVICES_URL}${process.env.VUE_APP_API_GET_TIPO_DOCUMENTOS}`
    this._additionalConfig = {
      headers: {
        'x-api-key': `${process.env.VUE_APP_API_PRIMARY_API_KEY}`
      }
    }
  }

  getDocumentsType() {
    return axios.get(this._documentTypeUrl, this._additionalConfig)
  }

  createDocumentType(documentType) {
    return axios.post(
      this._documentTypeUrl,
      documentType,
      this._additionalConfig
    )
  }

  updateDocumentType(id, documentType) {
    return axios.put(
      `${this._documentTypeUrl}/${id}`,
      documentType,
      this._additionalConfig
    )
  }

  deleteDocumentType(id) {
    return axios.delete(
      `${this._documentTypeUrl}/${id}`,
      this._additionalConfig
    )
  }
}
